import { render, staticRenderFns } from "./InfoText.vue?vue&type=template&id=1024da2c&"
import script from "./InfoText.vue?vue&type=script&lang=js&"
export * from "./InfoText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports